<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "assets/css/global.css";
@import "assets/css/vant-reset.css";
@import "../static/keyou-encrypt/whiteStyle.css";
/* @import "../node_modules/video.js/dist/video-js.css";
@import "../node_modules/vue-video-player/src/custom-theme.css"; */
</style>



// WEBPACK FOOTER //
// src/App.vue